// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreatedByLabel_wrapper__JOvf9","avatar":"CreatedByLabel_avatar__v7U_7"};